var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLamp = function SvgLamp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 76,
    height: 83,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#57CCF2",
    d: "M72.033 31.62h-3.942v-3.97h-3.97v3.97H60.18v3.942h-3.943v3.969h3.943v3.943h3.943v3.943h3.969v-3.943h3.942V39.53h3.943v-3.969h-3.943z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#57CCF2",
    d: "M60.18 27.65h-3.944v3.97h3.943zM56.237 51.385h-3.97v15.797h3.97z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#57CCF2",
    d: "M56.237 23.708h-3.97v3.943h3.97zM52.268 67.182h-3.943v3.969h3.943zM52.268 47.417h-3.943v3.968h3.943zM52.268 19.766h-3.943v3.942h3.943zM48.325 39.531h-3.969v7.886h3.969zM48.325 15.797h-3.969v3.969h3.969z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#57CCF2",
    d: "M48.325 11.854V7.911h-3.969V3.943h-3.943V0h-3.942v3.943h-3.969V7.91H28.56v3.943h3.943v3.943h3.969v3.969h3.943v-3.97h3.942v-3.942zM28.56 71.15v7.886h-3.943v3.969h27.65v-3.969h-3.942v-7.885zM44.356 31.62h-3.942v7.911h3.942zM36.47 51.385h-3.968v3.943H28.56v3.943h3.943v3.969h3.969v3.942h3.943V63.24h3.942v-3.97h3.969v-3.942h-3.969v-3.943h-3.943V39.531h-3.942zM40.413 27.65h-3.942v3.97h3.942zM36.47 31.62h-3.968v7.911h3.969z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#57CCF2",
    d: "M32.502 39.531H28.56v7.886h3.943zM32.502 15.797H28.56v3.969h3.943zM28.56 67.182h-3.943v3.969h3.942zM28.56 47.417h-3.943v3.968h3.942zM28.56 19.766h-3.943v3.942h3.942z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#57CCF2",
    d: "M24.617 51.385h-3.97v15.797h3.97zM24.617 23.708h-3.97v3.943h3.97z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#57CCF2",
    d: "M20.648 27.65h-3.943v3.97h3.943z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#57CCF2",
    d: "M12.737 27.65H8.794v3.97H4.85v3.942H.882v3.969h3.969v3.943h3.943v3.943h3.942v-3.943h3.97V39.53h3.942v-3.969h-3.943V31.62h-3.968z"
  })));
};
export default SvgLamp;